import {
  calculateTotal,
  PivotAgingPartyWise,
  PivotDataSummary,
} from "../../Utility/utility"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { ErrorCard, LoadingCard, NextUITable } from "../../components"
import { apiRoute, GetLoginCredentialDb, linksUrl, outTypeEnum } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { CardBody, Card, Chip, Accordion, AccordionItem, Input, Button, Radio, RadioGroup, PopoverContent, PopoverTrigger, Popover } from "@nextui-org/react"
import { useEffect, useMemo, useRef, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleDown, faChartPie, faFilter, faIndianRupeeSign, faListCheck, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  SELECTION_MODE,
} from "../../components/NextUITable"
import { useModalToast } from "../../components/modalToast/ModalToastContext"

export const DashboardPartywiseOutstanding = () => {
  const { compCode, yearId } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  let [isReceivable, setIsReceivable] = useState("1")
  let [filterAging, setFilterAging] = useState({ age1: 100000, age2: 200000, age3: 300000, age4: 400000 })
  const [applyAging, setApplyAging] = useState({ age1: 100000, age2: 200000, age3: 300000, age4: 400000 })
  const inputRef = useRef(null);
  const { show } = useModalToast();
  const {
    isPending,
    isError,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.dashboard.getOutsPartyAgingData,
    queryKey: "DashboardOutAgingRec",

  })
  const formatIndianNumber = (num) => {
    if (num >= 100000) {
      return `${parseFloat((num / 100000).toFixed(2))} Lakh`;
    }

    return num.toLocaleString("en-IN");
  };

  const aging = useMemo(() => {
    return {
      Age1: `<=${filterAging?.age1}`
      , Age2: `>${filterAging?.age1}<=${filterAging?.age2}`
      , Age3: `>${filterAging?.age2}<=${filterAging?.age3}`
      , Age4: `>${filterAging?.age3}<=${filterAging?.age4}`
      , Age5: `>${filterAging?.age4}`
    }
  }, [filterAging])

  const displayAging = useMemo(() => {
    return {
      Age1: `<= ${formatIndianNumber(filterAging?.age1)}`
      , Age2: `${formatIndianNumber(filterAging?.age1)} - ${formatIndianNumber(filterAging?.age2)}`
      , Age3: `${formatIndianNumber(filterAging?.age2)} - ${formatIndianNumber(filterAging?.age3)}`
      , Age4: `${formatIndianNumber(filterAging?.age3)} - ${formatIndianNumber(filterAging?.age4)}`
      , Age5: `> ${formatIndianNumber(filterAging?.age4)}`
    }
  }, [filterAging])
  const funLoadData = (filter) => {

    filterData({
      data: {
        compcode: compCode.join(","),
        out_type: isReceivable == "1" ? outTypeEnum.R : outTypeEnum.G,
        party_id: "0",
        age1: filter?.age1 || 100000,
        age2: filter?.age2 || 200000,
        age3: filter?.age3 || 300000,
        age4: filter?.age4 || 400000
      }
    })
  }
  useEffect(() => {
    funLoadData(filterAging);
  }, [filterAging, isReceivable])


  const totalAge5 = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: aging?.Age5,
      }),
    [data]
  )
  const totalAge4 = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: aging?.Age4,
      }),
    [data]
  )
  const totalAge3 = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: aging?.Age3,
      }),
    [data]
  )
  const totalAge2 = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: aging?.Age2,
      }),
    [data]
  )
  const totalAge1 = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: aging?.Age1,
      }),
    [data]
  )
  const handleResetAging = () => {
    const Age = { age1: 100000, age2: 200000, age3: 300000, age4: 400000 }
    setFilterAging(Age)
    setApplyAging(Age)
    funLoadData(Age)
  }

  const INITIAL_VISIBLE_COLUMNS = useMemo(() => {

    return ["party", aging?.Age1, aging?.Age2, aging?.Age3, aging?.Age4, aging?.Age5]

  }, [filterAging])
  
  const columns = useMemo(() => {
    return [
      {
        uid: "party",
        name: "Party",
        sortable: true,
      },

      {
        uid: aging?.Age1,
        name: displayAging?.Age1,
        type: COLUMN_TYPE.number,
        sortable: true,
        footer: {
          type: FOOTER_TYPE.text,
          label: "Total: ",
          value: totalAge1,
        },

      },
      {
        uid: aging?.Age2,
        name: displayAging?.Age2,
        type: COLUMN_TYPE.number,
        sortable: true,
        footer: {
          type: FOOTER_TYPE.text,
          label: "Total: ",
          value: totalAge2,
        },

      },
      {
        uid: aging?.Age3,
        name: displayAging?.Age3,
        type: COLUMN_TYPE.number,
        sortable: true,
        footer: {
          type: FOOTER_TYPE.text,
          label: "Total: ",
          value: totalAge3,
        },

      },
      {
        uid: aging?.Age4,
        name: displayAging?.Age4,
        type: COLUMN_TYPE.number,
        sortable: true,
        footer: {
          type: FOOTER_TYPE.text,
          label: "Total: ",
          value: totalAge4,
        },

      },
      {
        uid: aging?.Age5,
        name: displayAging?.Age5,
        type: COLUMN_TYPE.number,
        sortable: true,
        footer: {
          type: FOOTER_TYPE.text,
          label: "Total: ",
          value: totalAge5,
        },

      },
    ]

  }, [filterAging, handleResetAging])


  let downloadDataFooter = useMemo(() => {

    return {
      party: "",
      [aging?.Age1]: "Total: " + totalAge1,
      [aging?.Age2]: "Total: " + totalAge2,
      [aging?.Age3]: "Total: " + totalAge3,
      [aging?.Age4]: "Total: " + totalAge4,
      [aging?.Age5]: "Total: " + totalAge5,
    }

  }, [aging])

  const exportColumns = useMemo(() => {

    return [{
      uid: "party",
      name: "Party",
    },

    {
      uid: aging?.Age1,
      name: displayAging?.Age1,

    },
    {
      uid: aging?.Age2,
      name: displayAging?.Age2,

    },
    {
      uid: aging?.Age3,
      name: displayAging?.Age3,

    },
    {
      uid: aging?.Age4,
      name: displayAging?.Age4,

    },
    {
      uid: aging?.Age5,
      name: displayAging?.Age5,

    },
    ];


  }, [aging])

  const handleAgeBlur = (e) => { }
  const handleAgingChange = (e) => {
    const { value, name } = e.target
    setApplyAging({ ...applyAging, [name]: value })
  }
  const funValidateAging = (age1, age2, age3, age4) => {
    const newErrors = {
      age1: "",
      age2: "",
      age3: "",
      age4: "",
    };

    let isValid = true;


    if (Number(age1) >= Number(age2)) {
      isValid = false;
      newErrors.age1 = `Value of Age 1 must be < Age 2 (${age2})`;
    }

    // Age 2
    if (Number(age2) <= Number(age1)) {
      isValid = false;
      newErrors.age2 = `Value of Age 2 must be > Age 1 (${age1})`;
    } else if (Number(age2) >= Number(age3)) {
      isValid = false;
      newErrors.age2 = `Value of Age 2 must be < Age 3 (${age3})`;
    }

    // Age 3
    if (Number(age3) <= Number(age2)) {
      isValid = false;
      newErrors.age3 = `Value of Age 3 must be > Age 2 (${age2})`;
    } else if (Number(age3) >= Number(age4)) {
      isValid = false;
      newErrors.age3 = `Value of Age 3 must be < Age 4 (${age4})`;
    }

    if (!isValid) {
      // setApplyAging(filterAging)
      // show(<div><h6> {newErrors.age1}</h6>
      //   <h6> {newErrors.age2}</h6>
      //   <h6> {newErrors.age3}</h6>
      //   <h6> {newErrors.age4}</h6>

      // </div>)
      return newErrors;
    }
    return ""
  }

  const topActionFilter = []

  const handleAgingFilter = () => {
    const valid = funValidateAging(applyAging?.age1, applyAging?.age2, applyAging?.age3, applyAging?.age4)

    if (valid != "") {
      show(<div><h6> {valid.age1}</h6>
        <h6> {valid.age2}</h6>
        <h6> {valid.age3}</h6>
        <h6> {valid.age4}</h6>

      </div>)
      return;
    }
    setFilterAging(applyAging)
    // setData([])
    funLoadData(applyAging)
  }

  if (isError) { return <ErrorCard /> }
  if (isPending) { return <LoadingCard /> }
  return (
    <div>

      <div className={` mb-1 p-2 rounded-lg border transition-all duration-200  bg-orange-50 border-orange-300 hover:border-orange-300  `} >

        <RadioGroup label="" size="sm" color="secondary" value={isReceivable}
          onValueChange={setIsReceivable} orientation="horizontal" className="h-8" classNames={{ wrapper: "gap-5", }} >
          <Radio value="1" classNames={{
            base: `m-0 px-3 py-0.7 rounded-md cursor-pointer transition-all duration-200 
                                                    ${isReceivable === "1" ? "bg-orange-500 shadow-sm" : "bg-white hover:bg-orange-100"} `,
            label: ` text-sm font-bold ${isReceivable === "1" ? "text-white" : "text-orange-600"} `,
            //control: "hidden",
          }} > RECEIVABLE </Radio>
          <Radio value="0" classNames={{
            base: ` m-0 px-3 py-0.7 rounded-md cursor-pointer transition-all duration-200 
                                ${isReceivable === "0" ? "bg-orange-500 shadow-sm" : "bg-white hover:bg-orange-100"} `,
            label: ` text-sm font-bold ${isReceivable === "0" ? "text-white" : "text-orange-600"} `,
            //control: "hidden",
          }} > PAYABLE </Radio>
        </RadioGroup> </div>

      <div className="w-full rounded-lg border border-gray-200 bg-gray-50 p-3 shadow-sm sm:p-4 mb-2">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-6 md:items-end md:gap-4 m-0 p-0">
          {/* Age 1 */}
          <Input type="text" ref={inputRef} label="Age 1" name="age1" color="success"
            isRequired placeholder=" " variant="bordered" labelPlacement="outside" size="sm"
            className="w-full bg-white"
            classNames={{
              label: "text-xs font-semibold uppercase text-orange-600",
              input: "text-sm font-semibold text-gray-800", inputWrapper: "h-9 border-gray-300 hover:border-orange-400 focus-within:border-orange-500",
            }}
            onFocus={(e) => e.target.select()} onBlur={handleAgeBlur} value={applyAging?.age1 ?? ""}
            onChange={handleAgingChange} />
          {/* Age 2 */} <Input type="text" ref={inputRef} label="Age 2" name="age2" color="success"
            isRequired placeholder=" " variant="bordered" labelPlacement="outside" size="sm"
            className="w-full bg-white" classNames={{
              label: "text-xs font-semibold uppercase text-orange-600",
              input: "text-sm font-semibold text-gray-800", inputWrapper: "h-9 border-gray-300 hover:border-orange-400 focus-within:border-orange-500",
            }}
            onFocus={(e) => e.target.select()}
            onBlur={handleAgeBlur} value={applyAging?.age2 ?? ""} onChange={handleAgingChange} />
          {/* Age 3 */} <Input type="text" ref={inputRef} label="Age 3" name="age3" color="success" isRequired placeholder=" " variant="bordered"
            labelPlacement="outside" size="sm" className="w-full bg-white"
            classNames={{
              label: "text-xs font-semibold uppercase text-orange-600", input: "text-sm font-semibold text-gray-800",
              inputWrapper: "h-9 border-gray-300 hover:border-orange-400 focus-within:border-orange-500",
            }}
            onFocus={(e) => e.target.select()} onBlur={handleAgeBlur} value={applyAging?.age3 ?? ""}
            onChange={handleAgingChange} />
          {/* Age 4 */} <Input type="text" ref={inputRef} label="Age 4" name="age4" color="success" isRequired placeholder=" "
            variant="bordered" labelPlacement="outside" size="sm" className="w-full bg-white"
            classNames={{
              label: "text-xs font-semibold uppercase text-orange-600", input: "text-sm font-semibold text-gray-800",
              inputWrapper: "h-9 border-gray-300 hover:border-orange-400 focus-within:border-orange-500",
            }}
            onFocus={(e) => e.target.select()} onBlur={handleAgeBlur} value={applyAging?.age4 ?? ""}
            onChange={handleAgingChange} /> {/* Buttons */} <div className="col-span-2 flex gap-2 md:col-span-2 md:justify-end">
            <Button onPress={handleAgingFilter} color="danger" variant="shadow" size="sm"
              className="h-9 flex-1 min-w-20 font-semibold md:flex-none uppercase" > Apply </Button>
            <Button onPress={handleResetAging} color="warning" variant="flat" size="sm"
              className="h-9 flex-1 min-w-20 bg-slate-700 text-white font-semibold md:flex-none uppercase" > Reset </Button>
          </div> </div> </div>


      <div className="">
        {/* table */}

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          id={"party"}
          showTopContent={true}
          topActionFilter={topActionFilter}
          rowSelection={false}
          showPagination={true}
          showFooter={true}
          showAdvanceFilter={false}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName={` PartyWise_${isReceivable ? "Receivable" : "Payable"} _Outstanding_Report`}
        />


      </div>


    </div>
  )
}
